<template>
  <div>
    <documents-crud-list
      title="Organisation administrative"
      category="Organisation administrative"
    />
  </div>
</template>

<script>
import DocumentsCrudList from './UIComponents/DocumentsCrudList.vue';

export default {
  components: {
    DocumentsCrudList,
  },
};
</script>
